import React from "react";

const MarsbetLoading = (props) => {
	return (
		<svg
			id="Frame50067"
			width="220"
			height="220"
			viewBox="0 0 220 220"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M169.2 31.6L123.6 12.7C114.9 9.1 105.2 9.1 96.5 12.7L50.9 31.6C42.2 35.2 35.3 42.1 31.7 50.8L12.7 96.4C9.1 105.1 9.1 114.8 12.7 123.5L31.6 169.1C35.2 177.8 42.1 184.7 50.8 188.3L96.4 207.2C105.1 210.8 114.8 210.8 123.5 207.2L169.1 188.3C177.8 184.7 184.7 177.8 188.3 169.1L207.2 123.5C210.8 114.8 210.8 105.1 207.2 96.4L188.3 50.8C184.7 42.1 177.8 35.2 169.1 31.6H169.2Z"
				fill="url(#paint0_linear_7314_871086)"
				strokeDasharray="0,0,0,617.7382202148438">
				<animate
					attributeType="XML"
					attributeName="stroke-dasharray"
					repeatCount="indefinite"
					dur="1.4285714285714286s"
					values="0,0,0,617.7382202148438; 
                  0,308.8691101074219,308.8691101074219,0; 
                  617.7382202148438,0,0,0"
					keyTimes="0; 0.5; 1"
					fill="freeze"></animate>
			</path>
			<path
				d="M169.2 31.6L123.6 12.7C114.9 9.1 105.2 9.1 96.5 12.7L50.9 31.6C42.2 35.2 35.3 42.1 31.7 50.8L12.7 96.4C9.1 105.1 9.1 114.8 12.7 123.5L31.6 169.1C35.2 177.8 42.1 184.7 50.8 188.3L96.4 207.2C105.1 210.8 114.8 210.8 123.5 207.2L169.1 188.3C177.8 184.7 184.7 177.8 188.3 169.1L207.2 123.5C210.8 114.8 210.8 105.1 207.2 96.4L188.3 50.8C184.7 42.1 177.8 35.2 169.1 31.6H169.2Z"
				fill="black"
				fillOpacity="0.5"
				strokeDasharray="0,0,0,617.7382202148438">
				<animate
					attributeType="XML"
					attributeName="stroke-dasharray"
					repeatCount="indefinite"
					dur="1.4285714285714286s"
					values="0,0,0,617.7382202148438; 
                  0,308.8691101074219,308.8691101074219,0; 
                  617.7382202148438,0,0,0"
					keyTimes="0; 0.5; 1"
					fill="freeze"></animate>
			</path>
			<path
				d="M121.688 17.3201L166.628 35.9463C166.807 36.048 166.994 36.1396 167.188 36.2201C174.662 39.3126 180.587 45.2382 183.68 52.7118L183.681 52.7144L202.58 98.3118C205.673 105.788 205.673 114.112 202.58 121.588L183.681 167.186L183.68 167.188C180.587 174.662 174.662 180.587 167.188 183.68L167.186 183.681L121.588 202.58C114.112 205.673 105.788 205.673 98.3118 202.58L52.7144 183.681L52.7118 183.68C45.2382 180.587 39.3126 174.662 36.2201 167.188L36.219 167.186L17.3201 121.588C17.3198 121.588 17.3195 121.587 17.3192 121.586C17.3191 121.586 17.319 121.586 17.319 121.586C14.2275 114.112 14.227 105.791 17.3176 98.3177C17.3184 98.3157 17.3193 98.3137 17.3201 98.3118L36.3154 52.7231L36.3201 52.7118C39.4126 45.2382 45.3382 39.3126 52.8118 36.2201L52.8144 36.219L98.4118 17.3201C98.4125 17.3198 98.4132 17.3195 98.4139 17.3192C98.4141 17.3191 98.4143 17.319 98.4144 17.319C105.889 14.227 114.211 14.227 121.686 17.319C121.686 17.319 121.686 17.3191 121.686 17.3192C121.687 17.3195 121.688 17.3198 121.688 17.3201Z"
				stroke="#F0052F"
				strokeWidth="10"
				strokeLinejoin="round"
				strokeDasharray="0,0,0,586.1314086914062">
				<animate
					attributeType="XML"
					attributeName="stroke-dasharray"
					repeatCount="indefinite"
					dur="1.4285714285714286s"
					values="0,0,0,586.1314086914062; 
                  0,293.0657043457031,293.0657043457031,0; 
                  586.1314086914062,0,0,0"
					keyTimes="0; 0.5; 1"
					fill="freeze"></animate>
			</path>
			<path
				d="M95.7342 10.8524L50.1353 29.752C50.1349 29.7521 50.1346 29.7523 50.1342 29.7524C40.9449 33.5552 33.6559 40.8439 29.8528 50.0332C29.8526 50.0339 29.8523 50.0346 29.852 50.0353L10.8538 95.6308L10.852 95.6353C7.04934 104.825 7.04934 115.075 10.852 124.265L10.8524 124.266L29.752 169.865C33.5548 179.055 40.8441 186.344 50.0342 190.148C50.0346 190.148 50.0349 190.148 50.0353 190.148L95.6342 209.048L95.6353 209.048C104.825 212.851 115.075 212.851 124.265 209.048L124.266 209.048L169.865 190.148C169.865 190.148 169.865 190.148 169.866 190.148C179.056 186.345 186.345 179.056 190.148 169.866C190.148 169.865 190.148 169.865 190.148 169.865L209.048 124.266L209.048 124.265C212.851 115.075 212.851 104.825 209.048 95.6353L209.048 95.6342L190.148 50.0353C190.148 50.0349 190.148 50.0346 190.148 50.0342C186.408 40.9979 179.298 33.7993 170.324 29.9458C170.214 29.8705 170.094 29.8054 169.966 29.7524L124.366 10.8524L124.365 10.852C115.175 7.04934 104.925 7.04934 95.7353 10.852L95.7342 10.8524Z"
				stroke="#940136"
				strokeWidth="4"
				strokeLinejoin="round"
				strokeDasharray="0,0,0,630.1165771484375">
				<animate
					attributeType="XML"
					attributeName="stroke-dasharray"
					repeatCount="indefinite"
					dur="1.4285714285714286s"
					values="0,0,0,630.1165771484375; 
                  0,315.05828857421875,315.05828857421875,0; 
                  630.1165771484375,0,0,0"
					keyTimes="0; 0.5; 1"
					fill="freeze"></animate>
			</path>
			<path
				d="M83.5 69H66V151.5H86.3V100.2L108.1 126.2H111.1L133.2 100.2V151.6H153.5V69H136L109.8 99.9L83.6 69H83.5Z"
				fill="white"
				strokeDasharray="0,0,0,495.578125">
				<animate
					attributeType="XML"
					attributeName="stroke-dasharray"
					repeatCount="indefinite"
					dur="1.4285714285714286s"
					values="0,0,0,495.578125; 
                  0,247.7890625,247.7890625,0; 
                  495.578125,0,0,0"
					keyTimes="0; 0.5; 1"
					fill="freeze"></animate>
			</path>
			<defs>
				<linearGradient
					id="paint0_linear_7314_871086"
					x1="109.95"
					y1="10"
					x2="109.95"
					y2="209.9"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#F0052F"></stop>
					<stop
						offset="1"
						stopColor="#940136"></stop>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default MarsbetLoading;
